import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
  ApplicationContextualHelp,
  ApplicationSectionHeader,
  ApplicationSurface,
} from "../../../components/application";
import LiveSessionJoinForm from "../../../activities/live-sessions/session-views/join-session-files/LiveSessionJoinForm";
import {
  buildJoinedLiveSessionRoute,
} from "../../../activities/live-sessions/session-views/join-session-files/liveJoinRuntimeRoute";

export default function ParticipateJoinLiveSection({
  headingLevel = 2,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const joinLiveSessionTitle = t(
    "participate_join_live_title",
    "Join a live session"
  );

  const handleSessionJoined = (
    code,
    _selectedSample,
    participantName,
    joinResponse
  ) => {
    navigate(
      buildJoinedLiveSessionRoute({
        code,
        participantName,
        runtimeKind:
          joinResponse?.session?.runtimeKind || null,
      })
    );
  };

  return (
    <section aria-labelledby="participate-join-live-title">
      <ApplicationSectionHeader
        description={t(
          "participate_join_live_description",
          "Enter the code shared by a facilitator to open the live activity you were invited to complete."
        )}
        headingLevel={headingLevel}
        title={(
          <span className="av-app-section-header__title-row">
            <span>{joinLiveSessionTitle}</span>
            <ApplicationContextualHelp
              label="About live sessions"
              title="About live sessions"
            >
              <p>
                Live sessions are activities run by a facilitator in real
                time. The facilitator starts a session from{" "}
                <Link to="/app/facilitate">Facilitate</Link> and
                shares a session code with participants. Enter that code here
                to join.
              </p>
            </ApplicationContextualHelp>
          </span>
        )}
        titleId="participate-join-live-title"
      />

      <ApplicationSurface>
        <LiveSessionJoinForm
          onSessionJoined={handleSessionJoined}
        />
      </ApplicationSurface>
    </section>
  );
}
